import { action, makeObservable } from 'mobx';

import {
  ITableColumnModel,
  TableFactoryHeaderStore,
  ToggleStateStore,
} from 'stores/common';
import { ILocalStore } from 'stores/interfaces';

type ColumnsSettingsDrawerParams = {
  headerStore: TableFactoryHeaderStore;
};

/** Стор для управления видимости колонок */
class ColumnsSettingsDrawerStore implements ILocalStore {
  constructor({ headerStore }: ColumnsSettingsDrawerParams) {
    this._headersFactoryStore = headerStore;

    makeObservable<ColumnsSettingsDrawerStore>(this, {
      reset: action.bound,
    });
  }

  private readonly _headersFactoryStore: TableFactoryHeaderStore;

  readonly drawerState = new ToggleStateStore();

  get entities(): ITableColumnModel[] {
    return this._headersFactoryStore.columns;
  }

  /** Сбрасываем состояние скрытых колонок до изначального */
  reset(): void {
    this._headersFactoryStore.columns.forEach((model) =>
      model.setOpenedState(true)
    );
  }

  destroy() {
    this.drawerState.destroy();
  }
}

export default ColumnsSettingsDrawerStore;
